import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/verification/admin/adminVerificationQueryKeys.ts
var t = e("admin-verifications", {
	list: (e, t, n) => e === void 0 && t === void 0 && n === void 0 ? ["list"] : [
		"list",
		e,
		t,
		n
	],
	detail: (e, t) => [
		"detail",
		e,
		t
	],
	stats: () => ["stats"]
});
//#endregion
export { t as adminVerificationQueryKeys };
